import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import api from './api';

Vue.use(ElementUI);
Vue.config.productionTip = false;

const DEFAULT_TITLE = '快提货';

async function initSiteName() {
  try {
    const res = await api.get('/other/public/settings', { params: { keys: 'site_name' } });
    const d = res.data || {};
    return d.site_name || DEFAULT_TITLE;
  } catch (e) { return DEFAULT_TITLE; }
}

const siteNamePromise = initSiteName();

router.afterEach(async (to) => {
  const siteName = await siteNamePromise;
  const pageTitle = to.meta.title ? `${to.meta.title} - ${siteName}` : `${siteName} - 便捷提货平台`;
  document.title = pageTitle;
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
